import { useQuery } from "@tanstack/react-query";
import { Link, useParams } from "@tanstack/react-router";
import { useEffect, useRef } from "react";
import { q } from "../../api.ts";
import { titleOf } from "../../inbox-items.ts";
import { INBOX_LABELS as I } from "../../labels.ts";
import { RuleProposal } from "../../product-rules.tsx";
import { Callout, Pill } from "../../ui.tsx";
import { ProductLabel } from "../../ui/product-label.tsx";
import { DetailPanelShell, Review, useInbox } from "./shared.tsx";

// Rules an agent proposed for one product: the person keeps or declines each, here or on the profile's Rules tab.

export function RuleReview() {
  const { ruleProductId } = useParams({ strict: false }) as { ruleProductId: string };
  const { items, done } = useInbox();
  const item = items.find((entry) => entry.key === `rule_review:${ruleProductId}`);
  const rules = useQuery(q.productRules(ruleProductId));
  const waiting = rules.data?.filter((rule) => rule.status === "proposed") ?? null;
  // The last decision moves on to the next item, as the other reviews do.
  const waited = useRef(false);
  useEffect(() => {
    if (waiting?.length) waited.current = true;
    else if (waiting && waited.current) { waited.current = false; done(I.rulesDone); }
  }, [waiting, done]);
  if (!item) return <DetailPanelShell><Callout>{I.closed}</Callout></DetailPanelShell>;
  return <Review label={I.detail} title={titleOf(item)}
    meta={<><Pill tone="amber" status>{I.reason[item.reason.code] ?? item.reason.code}</Pill><ProductLabel product={item.product} /></>}>
    <div className="z-flow">{waiting?.map((rule) => <RuleProposal key={rule.id} rule={rule} productId={item.product.id} />)}</div>
    <p><Link to="/p/$productId/profile" params={{ productId: item.product.id }} search={{ view: "rules" }}>{I.openProfileRules}</Link></p>
  </Review>;
}
